/* eslint-disable */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Card, CardBody, Col, CardHeader,
  Row } from 'reactstrap'
import { getRegs, getDocs } from '../../../utils/fc'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import PqGridView from '../../Modal/PqGridView'
import moment from 'moment'
import {MaterialReactTable} from 'material-react-table'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Edit from '@material-ui/icons/Edit'
import AttachFile from '@mui/icons-material/AttachFile'
import ReceiptLong from '@mui/icons-material/ReceiptLong'
import Search from '@mui/icons-material/Search'
import ModalProcessoFaturamento from './ModalProcessoFaturamento'
import FatSupportDocsIcon from '../../Financial/FatSupportDocsIcon'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from '@mui/material'
import Dropzone from 'react-dropzone'
import api_powerapps from '../../../services/powerapps/index'
import oikosApi from '../../../services/oikos'
import { uploadFileToDocumento } from '../../../utils/oikosUploadDocumento'
import { OIKOS_FILES_BASE, TP_DOC_REC_LIBERACAO_FATURAMENTO } from '../../../constants/oikosReceitas'
import { notifyError, notifySuccess } from '../../../utils/notify'

const num = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

/** Valor numérico → máscara tipo 1.234,56 (sempre 2 decimais). */
const formatBrlFromNumber = (n) => {
  if (n == null || n === '') return ''
  const v = Number(n)
  if (!Number.isFinite(v)) return ''
  const cents = Math.round(v * 100)
  const s = String(Math.abs(cents)).padStart(3, '0')
  const intRaw = s.slice(0, -2) || '0'
  const dec = s.slice(-2)
  const intFmt = intRaw.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const sign = v < 0 ? '-' : ''
  return `${sign}${intFmt},${dec}`
}

/** Somente dígitos digitados → máscara 1.234,56 */
const digitsToBrlMask = (digitsRaw) => {
  const digits = String(digitsRaw || '').replace(/\D/g, '')
  if (!digits) return ''
  const n = Number(digits) / 100
  return formatBrlFromNumber(n)
}

/** Máscara 1.234,56 → número */
const parseBrlMaskedToNumber = (masked) => {
  const digits = String(masked || '').replace(/\D/g, '')
  if (!digits) return NaN
  return Number(digits) / 100
}

const filterLibDocs = (docs) => {
  const list = Array.isArray(docs) ? docs : []
  return list
    .filter((d) => Number(d?.tpDocumento_id) === Number(TP_DOC_REC_LIBERACAO_FATURAMENTO))
    .sort((a, b) => Number(b?.arquivo_id || 0) - Number(a?.arquivo_id || 0))
}

const isRecAutorizado = (rec) => Number(rec?.rec_aut) === 1

class EvePag extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      dataIsLoading: false,
      pqGridViewIsOpen: false,
      modalLibOpen: false,
      modalRecRow: null,
      recLibDocs: [],
      libForm: { dtLib: '', vlrLib: '', just: '', pdfFiles: [] },
      libSubmitting: false,
      modalFatOpen: false,
    }
  }

  componentDidMount() {
    this.credentialsOikos()
    this.preloading()
  }

  preloading = async() => {
    this.setState({ dataIsLoading: true })
    const raw = await getRegs('rec', { orcRubr_id: this.props.orcRubr_id })
    const list = Array.isArray(raw) ? raw : []
    const enriched = await Promise.all(
      list.map(async (r) => {
        try {
          const d = await getDocs('rec', r.rec_id)
          const libDocs = filterLibDocs(d)
          return { ...r, _libAnexoCount: libDocs.length }
        } catch (e) {
          return { ...r, _libAnexoCount: 0 }
        }
      })
    )
    this.setState({ data: enriched, dataIsLoading: false })
  }

  getLibDocsSorted = () => filterLibDocs(this.state.recLibDocs)

  openDoc = (doc) => {
    const path = doc?.arquivo_caminho
    if (!path) return
    window.open(`${OIKOS_FILES_BASE}${path}`, '_blank')
  }

  openModalLibera = async (rec) => {
    let recLibDocs = []
    try {
      const d = await getDocs('rec', rec.rec_id)
      recLibDocs = Array.isArray(d) ? d : []
    } catch (e) {
      console.log('getDocs rec', e)
    }
    const today = moment().format('YYYY-MM-DD')
    const dtLib = rec.rec_dtLibAutNf
      ? moment(rec.rec_dtLibAutNf).format('YYYY-MM-DD')
      : today
    const vlrSrc =
      rec.rec_vlrLibAutNf != null && rec.rec_vlrLibAutNf !== ''
        ? rec.rec_vlrLibAutNf
        : rec.rec_vlrBru
    const vlrLib = formatBrlFromNumber(vlrSrc)
    this.setState({
      modalLibOpen: true,
      modalRecRow: rec,
      recLibDocs,
      libForm: {
        dtLib,
        vlrLib,
        just: rec.rec_justDifLibAutNf || '',
        pdfFiles: [],
      },
    })
  }

  closeModalLibera = () => {
    if (this.state.libSubmitting) return
    this.setState({
      modalLibOpen: false,
      modalRecRow: null,
      recLibDocs: [],
      libForm: { dtLib: '', vlrLib: '', just: '', pdfFiles: [] },
    })
  }

  setLibField = (field, value) => {
    this.setState((s) => ({
      libForm: { ...s.libForm, [field]: value },
    }))
  }

  onVlrLibChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '')
    const masked = digitsToBrlMask(digits)
    this.setLibField('vlrLib', masked)
  }

  submitLibera = async () => {
    const { modalRecRow, libForm, recLibDocs } = this.state
    if (!modalRecRow?.rec_id) return
    if (isRecAutorizado(modalRecRow)) return
    const bru = num(modalRecRow.rec_vlrBru)
    const lib = parseBrlMaskedToNumber(libForm.vlrLib)
    const existingLib = filterLibDocs(recLibDocs)
    const hasExisting = existingLib.length > 0
    const newFiles = libForm.pdfFiles || []
    const needJust = Math.abs(bru - lib) > 0.01

    if (!libForm.dtLib) {
      notifyError('Informe a data da liberação.')
      return
    }
    if (moment(libForm.dtLib).isAfter(moment(), 'day')) {
      notifyError('A data da liberação não pode estar no futuro.')
      return
    }
    if (!Number.isFinite(lib)) {
      notifyError('Informe o valor liberado.')
      return
    }
    if (needJust && !(libForm.just && String(libForm.just).trim())) {
      notifyError('Informe a justificativa para a diferença em relação ao valor bruto previsto.')
      return
    }
    if (!hasExisting && newFiles.length === 0) {
      notifyError('Inclua pelo menos um PDF de liberação de faturamento.')
      return
    }

    this.setState({ libSubmitting: true })
    try {
      for (let i = 0; i < newFiles.length; i += 1) {
        const file = newFiles[i]
        await uploadFileToDocumento({
          tpDocumentoId: TP_DOC_REC_LIBERACAO_FATURAMENTO,
          tabRef: 'rec',
          tabId: modalRecRow.rec_id,
          file,
          documentoDesc: `Liberação faturamento (rec_id ${modalRecRow.rec_id})${newFiles.length > 1 ? ` [${i + 1}/${newFiles.length}]` : ''}`,
        })
      }

      await oikosApi.post('/', {
        action: 'update',
        table: 'rec',
        data: {
          rec_id: modalRecRow.rec_id,
          rec_aut: 1,
          rec_dtLibAutNf: libForm.dtLib,
          rec_vlrLibAutNf: lib,
          rec_justDifLibAutNf: needJust ? String(libForm.just).trim() : null,
        },
      })
      notifySuccess('Liberação de faturamento registrada.')
      this.setState({
        modalLibOpen: false,
        modalRecRow: null,
        recLibDocs: [],
        libForm: { dtLib: '', vlrLib: '', just: '', pdfFiles: [] },
        libSubmitting: false,
      })
      await this.preloading()
    } catch (e) {
      console.log(e)
      notifyError(e?.message || 'Falha ao registrar liberação.')
      this.setState({ libSubmitting: false })
    }
  }

  renderAutorizado = (rec_aut) => {
    const ok = Number(rec_aut) === 1
    // Mesmas cores que «Faturado?» (renderPmtFat): Sim = badge-info, Não = badge-warning
    const cls = ok ? 'badge badge-info' : 'badge badge-warning'
    return <span className={cls}>{ok ? 'Sim' : 'Não'}</span>
  }

  renderPmtFat = (fat) => {
    let fat_badge
    let fat_label
    switch (fat) {
      case 0:
        fat_badge = `badge badge-warning` // Pendente
        fat_label = `Não` // Pendente
        break
      case 1:
        fat_badge = `badge badge-info` // Faturado
        fat_label = `Sim` // Pendente
        break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  renderPmtStatus = (risk) => {
    let fat_badge
    let fat_label
    switch (Number(risk)) {
      case 0:
        fat_badge = `badge badge-info` // Sim
        fat_label = `Sim`
        break
      default:
        fat_badge = `badge badge-warning` // Não
        fat_label = `Não`
        break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  renderPmtRisk = (fat) => {
    let fat_badge
    let fat_label
    switch (fat) {
      case 0:
        fat_badge = `badge badge-info` // Pendente
        fat_label = `Pago` // Pendente
        break
      case 1:
        fat_badge = `badge badge-success` // Faturado
        fat_label = `Baixo` // Pendente
        break
      case 2:
        fat_badge = `badge badge-warning` // Faturado
        fat_label = `Médio` // Pendente
        break
      case 3:
        fat_badge = `badge badge-danger` // Faturado
        fat_label = `Alto` // Pendente
        break
        case 4:
          fat_badge = `badge badge-danger` // Faturado
          fat_label = `Não avaliado` // Pendente
          break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  credentialsOikos = async() => {
    const formData = new FormData()
    try {
      formData.append('acao', 'get_credentials')
      formData.append('user_email', this.props.auth.user.mail)
      const res = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })
      this.setState({ oikos_usuario: res.data.usuario_login, oikos_senha: res.data.usuario_senha})
    } catch (err) {
      console.log('Não foi possível logar no Oikos.', err)
    }
  }


  render() {

    const {
      dataIsLoading,
      data,
      oikos_usuario,
      oikos_senha,
      pqGridViewIsOpen,
      modalLibOpen,
      modalRecRow,
      libForm,
      libSubmitting,
      recLibDocs,
    } = this.state

    const bruModal = num(modalRecRow?.rec_vlrBru)
    const libModal = parseBrlMaskedToNumber(libForm.vlrLib)
    const needJustModal = Math.abs(bruModal - libModal) > 0.01
    const libDocsInModal = filterLibDocs(recLibDocs)
    const maxDtLib = moment().format('YYYY-MM-DD')
    const isLocked = modalRecRow ? isRecAutorizado(modalRecRow) : false
    const showJustField = needJustModal || (isLocked && String(modalRecRow?.rec_justDifLibAutNf || '').trim())

    const dropStyle = {
      cursor: 'pointer',
      borderWidth: 2,
      borderRadius: 6,
      borderColor: '#ccc',
      borderStyle: 'dashed',
      backgroundColor: '#f8f8f8',
      outline: 'none',
      textAlign: 'center',
      padding: '10px 12px',
      fontSize: 12,
      color: '#666',
    }

    const columns = [
      {
        accessorKey: 'rec_id',
        header: 'ID',
        size: 50,
      },
      {
        accessorKey: 'rec_ep',
        header: 'Descrição',
        size: 100,
        maxWidth: 200,
      },
      {
        accessorKey: 'rec_vlrBru',
        header: 'Valor Bruto',
        accessorFn: (row) => currencyFormatter.format(row.rec_vlrBru),
        size: 50,
      },
      {
        accessorKey: 'rec_vlrLiq',
        header: 'Valor Líquido',
        accessorFn: (row) => currencyFormatter.format(row.rec_vlrLiq),
        size: 50,
      },
      {
        header: 'Autorizado?',
        accessorFn: (row) => row.rec_aut,
        Cell: ({ row }) => this.renderAutorizado(row.original.rec_aut),
        size: 56,
      },
      {
        header: 'Faturado?',
        accessorFn: (row) => row.rec_fat,
        Cell: ({ renderedCellValue, row }) => this.renderPmtFat(renderedCellValue),
        size: 50,
      },
      {
        header: 'Pago?',
        accessorFn: (row) => row.rec_risco,
        Cell: ({ renderedCellValue, row }) => this.renderPmtStatus(renderedCellValue),
        size: 50,
      },
      {
        header: 'Risco',
        accessorFn: (row) => row.rec_risco,
        Cell: ({ renderedCellValue, row }) => this.renderPmtRisk(renderedCellValue),
        size: 50,
      },
      {
        accessorKey: 'rec_dtNfPrev',
        header: 'Limite para faturamento',
        accessorFn: (row) => {
          if (row.rec_dtNfPrev) {
            return moment(row.rec_dtNfPrev, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        Cell: ({cell, row}) => moment(cell.getValue()).format('DD/MM/YYYY'),
        size: 30,
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'rec_dtQuitAtual',
        header: 'Previsão de pagamento',
        accessorFn: (row) => {
          if (row.rec_dtQuitAtual) {
            return moment(row.rec_dtQuitAtual, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        Cell: ({cell, row}) => moment(cell.getValue()).format('DD/MM/YYYY'),
        size: 30,
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
    ]


    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    //isManager
    if (data) {
      return (
          <>
          <PqGridView
            isOpen={pqGridViewIsOpen}
            Path={`https://oikos.ecoss.is/oikos/bancodedados.rec.php?orcRubr_id=${this.props.orcRubr_id}&login123=${oikos_usuario}&pass123=${oikos_senha}`}
            Header={`Receitas`}
            toggle={() => {
              this.setState({
                pqGridViewIsOpen: false,
              })
              this.preloading()
            }} />
          <Card>
              <Row>
                <Col>
                  <CardHeader>
                    Eventos de pagamento
                  </CardHeader>
                    {!dataIsLoading && data?.length >= 0 && (
                      <MaterialReactTable
                        columns={columns}
                        data={data}
                        initialState={{
                          density: 'compact',
                          expanded: false, //expand all groups by default
                          pagination: { pageIndex: 0, pageSize: 20 },
                          sorting: [{ id: 'rec_dtQuitAtual', desc: false }], //sort by state by default
                        }}
                        enableFacetedValues
                        enableGrouping={false}
                        enableGlobalFilter={true}
                        enableFilters={true}
                        enablePagination={true}
                        enableRowActions
                        displayColumnDefOptions={{
                          'mrt-row-actions': { header: '', size: 56 },
                        }}
                        muiTopToolbarProps={{sx: {
                          '.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"},
                          '.MuiSvgIcon-root': {width: '12px'},
                          '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'},
                          '.MuiTablePagination-root .MuiToolbar-root': {minHeight: "30px !important", height: "30px !important"},
                          '.MuiTablePagination-root': {minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem"},
                        }}}

                        muiTableBodyCellProps={{sx: {fontSize: "13px", maxWidth: "100px"}}}
                        muiTablePaginationProps={{
                          sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, fontSize: "12px"},
                          labelRowsPerPage: <span style={{fontSize: "12px"}}>Eventos por página</span>,
                          rowsPerPageOptions: [50, 100],
                        }}
                        muiTableHeadCellProps={{
                          sx: {
                            fontSize: '12px',
                            fontWeight: 'normal', // Remove bold text in the header
                            padding: '8px', // Adjust padding to reduce white space
                          },
                        }}
                        filterFns={{
                          dateRangeFilterFn: (row, id, filterValue) => {

                            if (!filterValue || !filterValue[0] || !filterValue[1]) {
                              return true; // Return true to show all rows if the filter is cleared
                            }

                            return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                          },
                          valorRangeFilterFn: (row, id, filterValue) => {

                            if (!filterValue || !filterValue[0] || !filterValue[1]) {
                              return true; // Return true to show all rows if the filter is cleared
                            }

                            return ((row.getValue(id) >= (filterValue[0])) && (row.getValue(id) <= (filterValue[1])))
                          },
                        }}

                        renderTopToolbarCustomActions={() => (
                          <Box marginLeft="auto" sx={{ display: 'flex' }}>
                            <FatSupportDocsIcon rec={{ orcRubr_id: this.props.orcRubr_id }} />
                            <IconButton
                              title="Processo de faturamento"
                              onClick={() => this.setState({ modalFatOpen: true })}
                            >
                              <ReceiptLong />
                            </IconButton>
                            <IconButton
                              title="Editar eventos"
                              onClick={() => this.setState({ pqGridViewIsOpen: true })}
                            >
                              <Edit />
                            </IconButton>
                          </Box>
                        )}
                        renderRowActions={({ row }) => {
                          const r = row.original
                          const n = Number(r._libAnexoCount) || 0
                          if (n > 0) {
                            return (
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <IconButton
                                  size="small"
                                  color="primary"
                                  title={`Ver liberação (${n} anexo${n > 1 ? 's' : ''})`}
                                  onClick={() => this.openModalLibera(r)}
                                >
                                  <Search fontSize="small" />
                                </IconButton>
                              </Box>
                            )
                          }
                          return (
                            <Box>
                              <IconButton
                                size="small"
                                title="Registrar liberação de faturamento (PDF)"
                                onClick={() => this.openModalLibera(r)}
                              >
                                <AttachFile fontSize="small" />
                              </IconButton>
                            </Box>
                          )
                        }}
                      />
                  )}
                </Col>
              </Row>
          </Card>

          <Dialog open={modalLibOpen} onClose={this.closeModalLibera} fullWidth maxWidth="sm">
            <DialogTitle>Liberação de faturamento</DialogTitle>
            <DialogContent dividers>
              {modalRecRow && (
                <>
                  {isLocked && (
                    <Typography variant="body2" sx={{ mb: 2, p: 1.5, bgcolor: 'action.selected', borderRadius: 1 }}>
                      Faturamento já autorizado. Os dados abaixo não podem ser alterados.
                    </Typography>
                  )}
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    EP: <strong>{modalRecRow.rec_ep || '—'}</strong>
                    {' · '}
                    Valor bruto previsto: <strong>{currencyFormatter.format(num(modalRecRow.rec_vlrBru))}</strong>
                  </Typography>

                  {libDocsInModal.length > 0 && (
                    <Box sx={{ mb: 2, p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                        PDF(s) de liberação já enviados
                      </Typography>
                      {libDocsInModal.map((doc) => (
                        <Box key={doc.arquivo_id || doc.documento_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
                          <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }} noWrap title={doc.arquivo_desc || doc.documento_desc}>
                            {doc.arquivo_desc || doc.documento_desc || 'PDF'}
                          </Typography>
                          <Button size="small" variant="outlined" onClick={() => this.openDoc(doc)}>
                            Abrir PDF
                          </Button>
                        </Box>
                      ))}
                    </Box>
                  )}

                  <TextField
                    margin="dense"
                    label="Data da liberação"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ max: maxDtLib }}
                    value={libForm.dtLib}
                    onChange={(e) => this.setLibField('dtLib', e.target.value)}
                    disabled={libSubmitting || isLocked}
                  />
                  <TextField
                    margin="dense"
                    label="Valor liberado"
                    fullWidth
                    value={libForm.vlrLib}
                    onChange={this.onVlrLibChange}
                    disabled={libSubmitting || isLocked}
                    placeholder="0,00"
                    inputProps={{ inputMode: 'numeric', autoComplete: 'off' }}
                    helperText={!isLocked ? 'Formato: milhares com ponto, centavos após vírgula (ex.: 12.345,67)' : undefined}
                  />
                  {showJustField && (
                    <TextField
                      margin="dense"
                      label="Justificativa (valor liberado diferente do bruto previsto)"
                      fullWidth
                      multiline
                      minRows={3}
                      value={isLocked ? (modalRecRow.rec_justDifLibAutNf || '') : libForm.just}
                      onChange={(e) => this.setLibField('just', e.target.value)}
                      disabled={libSubmitting || isLocked}
                      required={!isLocked && needJustModal}
                    />
                  )}
                  {!isLocked && (
                    <>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1, mb: 0.5 }}>
                    {libDocsInModal.length > 0
                      ? 'Adicionar mais PDF(s) de autorização (opcional ao salvar alterações nos dados acima)'
                      : 'PDF(s) de autorização para emissão da NF (obrigatório na primeira vez)'}
                  </Typography>
                  <Dropzone
                    multiple
                    accept={['application/pdf', '.pdf']}
                    onDrop={(files) => {
                      const next = [ ...(libForm.pdfFiles || []), ...(files || []) ]
                      this.setLibField('pdfFiles', next)
                    }}
                    disabled={libSubmitting}
                  >
                    {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                      <div
                        {...getRootProps()}
                        style={{
                          ...dropStyle,
                          borderColor: isDragReject ? 'red' : isDragActive ? '#4aa3ff' : '#ccc',
                        }}
                      >
                        <input {...getInputProps()} />
                        Arraste um ou mais PDFs ou clique para selecionar
                      </div>
                    )}
                  </Dropzone>
                  {(libForm.pdfFiles || []).length > 0 && (
                    <Box sx={{ mt: 1 }}>
                      {(libForm.pdfFiles || []).map((f, idx) => (
                        <Typography key={`${f.name}-${idx}`} variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.name}</span>
                          <Button
                            size="small"
                            onClick={() => {
                              const rest = (libForm.pdfFiles || []).filter((_, i) => i !== idx)
                              this.setLibField('pdfFiles', rest)
                            }}
                            disabled={libSubmitting}
                          >
                            Remover
                          </Button>
                        </Typography>
                      ))}
                    </Box>
                  )}
                    </>
                  )}
                </>
              )}
            </DialogContent>
            <DialogActions>
              {isLocked ? (
                <Button onClick={this.closeModalLibera} variant="contained">
                  Fechar
                </Button>
              ) : (
                <>
                  <Button onClick={this.closeModalLibera} disabled={libSubmitting}>
                    Cancelar
                  </Button>
                  <Button variant="contained" onClick={this.submitLibera} disabled={libSubmitting}>
                    {libSubmitting ? 'Salvando…' : 'Autorizar faturamento'}
                  </Button>
                </>
              )}
            </DialogActions>
          </Dialog>

          <ModalProcessoFaturamento
            open={!!this.state.modalFatOpen}
            onClose={() => this.setState({ modalFatOpen: false })}
            projId={this.props.proj_id}
            contratoId={this.props.contrato_id}
          />

          </>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(EvePag)
